import { useEffect, useState } from "react";
import "./singleAuthor.css";
import Pagination from "../../components/pagination/Pagination";
import React from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { decodeHtml } from "../../utils/utils";
import Posts from "../posts/Posts";

export default function SingleAuthor() {
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const [author, setAuthor] = useState({ profilePic: "" });
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;
  const totalPages = Math.ceil(posts.length / postsPerPage);
  const [categoriesFromDB, setCategoriesFromDB] = useState([]);

  useEffect(() => {
    const getAuthor = async () => {
      try {
        const res = await axios.get("/users/" + path);

        if (res.status !== 200) {
          toast.info(res.data.message);
        }

        if (res.data.avatar_urls["full"] != null) {
          res.data.profilePic =
            process.env.REACT_APP_AWS_S3_IMAGE_URL +
            res.data.avatar_urls["full"];
        }

        setAuthor(res.data);
      } catch (err) {
        console.error("Error fetching author" + err);
        toast.error("Error Fetching Writer!");
      }
    };

    getAuthor();
  }, [path]);

  useEffect(() => {
    if (!author.userId) return;

    const getPosts = async () => {
      try {
        const res = await axios.get("/posts/published?user=" + author.userId);

        if (res.status !== 200) {
          toast.info(res.data.message);
        }
        setPosts(res.data);
      } catch (err) {
        console.error("Error fetching posts");
        toast.error("Error Fetching Posts!");
      }
    };

    getPosts();
  }, [author.userId]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("/categories");
        setCategoriesFromDB(res.data);
      } catch (err) {
        console.error("Failed to fetch categories", err);
        toast.error("Error fetching categories!");
      }
    };

  fetchCategories();
}, []);

  return (
    <div className="single-author-wrapper">
      <div className="author-section">
        <div className="author-image">
          <img src={author.profilePic} alt="Author" />
        </div>
        <div className="author-bio">
          <h2>{decodeHtml(author.user_name)}</h2>
          <p>{decodeHtml(author.bio)}</p>
        </div>
      </div>

      <div className="divider"></div>
      <div className="posted-article">
        <h2 className="posted-article-text">Posted Articles</h2>
        <div className="hide-post-elements">
          <Posts
            posts={posts.slice(
              (currentPage - 1) * postsPerPage,
              currentPage * postsPerPage
            )}
            categoriesFromDB={categoriesFromDB}
          />
        </div>

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            postsPerPage={postsPerPage}
            totalArticles={posts.length}
          />
        )}
      </div>
    </div>
  );
}
